const openCameraCommand = 'x-apple.systempreferences:com.apple.preference.security?Privacy_Camera';
const openScreenCaptureCommand = 'x-apple.systempreferences:com.apple.preference.security?Privacy_ScreenCapture';
const openMicrophoneCommand = 'x-apple.systempreferences:com.apple.preference.security?Privacy_Microphone';

firebird.factory('macSecurityPreferencesService', [
    '$window',
    'logService',
    'helperService',
    function ($window, logger, helperService) {
        const service = {
            openCamera: openCamera,
            openScreenCapture: openScreenCapture,
            openMicrophone: openMicrophone
        };

        return service;

        function openCamera() {
            if (helperService.isElectronOnMac()) {
                ensureSecurityPreferenceMethodExists('openCamera', openCameraCommand);

                $window.preloadedApi.systemPreferences.securityPreferences.openCamera().catch(function (err) {
                    logger.error(
                        'openCameraSystemPreference',
                        'electron Screen - Unable to open Camera System Preference',
                        err
                    );
                });
            }
        }

        function openScreenCapture() {
            if (helperService.isElectronOnMac()) {
                ensureSecurityPreferenceMethodExists('openScreenCapture', openScreenCaptureCommand);

                $window.preloadedApi.systemPreferences.securityPreferences.openScreenCapture().catch(function (err) {
                    logger.error(
                        'openScreenShareSystemPreference',
                        'electron Screen - Unable to open Screen Share System Preference',
                        err
                    );
                });
            }
        }

        function openMicrophone() {
            if (helperService.isElectronOnMac()) {
                ensureSecurityPreferenceMethodExists('openMicrophone', openMicrophoneCommand);

                $window.preloadedApi.systemPreferences.securityPreferences.openMicrophone().catch(function (err) {
                    logger.error(
                        'openMicrophoneSystemPreference',
                        'electron Screen - Unable to open Microphone System Preference',
                        err
                    );
                });
            }
        }

        function ensureSecurityPreferenceMethodExists(methodName, command) {
            if (!$window.preloadedApi.systemPreferences) {
                $window.preloadedApi.systemPreferences = {};
            }

            if (!$window.preloadedApi.systemPreferences.securityPreferences) {
                $window.preloadedApi.systemPreferences.securityPreferences = {};
            }

            if (!$window.preloadedApi.systemPreferences.securityPreferences[methodName]) {
                $window.preloadedApi.systemPreferences.securityPreferences[methodName] = () => {
                    return $window.preloadedApi.shell.openExternal(command);
                };
            }
        }
    }
]);
